import React from "react";
const EmployeeCard = ({ data }) => data ? (
  <div className="mt-3 p-3 bg-blue-50 border border-blue-100 rounded-lg flex items-center gap-3">
    <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
      {data.fullName[0]}
    </div>
    <div>
      <p className="text-xs font-bold text-blue-900">{data.fullName}</p>
      <p className="text-[10px] text-blue-700">{data.employeeId} | {data.position}</p>
    </div>
  </div>
) : null;
export default EmployeeCard;